import { Flame } from 'lucide-react'
import { LIST_TYPE } from '../../../lib/implant.js'
import { Badge } from '../../../kit'

/* The ประเภท cell — what a patient is on the implant lists (api 678 row `list`, or the
 * list letter of a call note). Shared by แท็บรอโทร and ผลการโทร so the two never word a
 * type differently. Warm Case keeps its amber badge (the warm lead stands out); an
 * extraction shows its age under the type. */
export default function ImplantType({ list }) {
  const t = LIST_TYPE[list]
  if (!t) return <span className="text-slate-300">—</span>
  if (list === 'W') return <Badge tone="amber"><Flame size={12} />{t.type}</Badge>
  return (
    <>
      <span className="block whitespace-nowrap">{t.type}</span>
      {t.age && <span className="block whitespace-nowrap text-[12px] text-slate-400">{t.age}</span>}
    </>
  )
}
